import PropTypes from "prop-types";
import React from "react";
import Select from "react-select";

export const FormDropDown = ({
  options,
  labelName,
  id,
  required = false,
  requiredAny = false,
  onChange,
  value,
  isMulti = false,
  error,
}) => {
  let borderColor = error ? "border-red-500" : "border-gray-300";
  let borderFocus = error ? "border-red-500" : "border-teal-300";

  const makeOptions = (x) => {
    return { value: x, label: x };
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#00bfae" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #00bfae" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#00bfae" : "#aaa",
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderColor: "#ccc",
    }),
    option: (provided, state) => {
      let backgroundColor;
      if (state.isSelected) {
        backgroundColor = "#e6f7f7";
      } else if (state.isFocused) {
        backgroundColor = "#f0f0f0";
      } else {
        backgroundColor = "white";
      }
      const color = state.isSelected ? "#00bfae" : "#333";

      return {
        ...provided,
        backgroundColor,
        color,
      };
    },
  };

  return (
    <div className="my-2 mt-0">
      <label className="block font-normal text-lg" htmlFor={id}>
        {labelName}
        {required && (
          <sup className="text-red-500 font-bold text-lg ml-1">*</sup>
        )}
        {requiredAny && (
          <sup className="text-red-500 font-bold text-lg ml-1">**</sup>
        )}
      </label>

      <Select
        options={options?.map((x) => makeOptions(x))}
        isMulti={isMulti}
        id={id}
        aria-labelledby={id}
        className={`form-control mt-1 block w-full mt-1 border ${borderColor} rounded-sm shadow-sm focus:${borderFocus} focus:ring-0 focus:outline-none`}
        styles={customStyles}
        onChange={onChange}
        value={value}
        aria-label={labelName}
      />
      {error && <span className="text-red-500 text-sm">{error.message}</span>}
    </div>
  );
};

FormDropDown.propTypes = {
  labelName: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  requiredAny: PropTypes.bool,
  isMulti: PropTypes.bool,
  error: PropTypes.object,
  id: PropTypes.string,
};
